module.exports = __webpack_public_path__ + "img/suspension-bridges--icon--gray.99161fcc.svg";